import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_URL, UPLOADS_API_URL } from "./config";

const ReceiptPayments = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    customer = {},
    totalAmount,
    operatorName,
    branchName,
    shiftId,
    companyDetails,
    branchDetails = [],
    paymentType,
    bankDetails,
  } = location.state;

  const [amountGiven, setAmountGiven] = useState(0);
  const changeAmount = amountGiven - totalAmount;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{backgroundColor: "#f8f9fa"}}>
      <div style={{ padding: "20px", backgroundColor: "#f8f9fa"}}>
    <div
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#f8f9fa",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: '100px'
      }}
    >
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          padding: "20px",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", 
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={`${
              companyDetails.horizontal_logo
                ? `${UPLOADS_API_URL}/${companyDetails.horizontal_logo.replace(
                    /\\/g,
                    "/"
                  )}`
                : "/assets/images/default-logo.png"
            }`}
            alt={`${companyDetails.trading_name} Logo`}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "150px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
        </div>

        <div className="modal-header">
          <div style={{ textAlign: "center", width: "100%" }}>
            <h2 style={{ margin: "0", color: "blue" }}>
              {companyDetails.trading_name}
            </h2>

            <div>
              {branchDetails.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <p>
                    <strong>Branch Name:</strong> {branchDetails[0].branch_name}
                  </p>
                </div>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={`${
                      companyDetails.sub_logo
                        ? `${UPLOADS_API_URL}/${companyDetails.sub_logo.replace(
                            /\\/g,
                            "/"
                          )}`
                        : "/assets/images/default-logo.png"
                    }`}
                    alt={`${companyDetails.name} Logo`}
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "150px",
                      objectFit: "contain",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              </div>

              <div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Date: <span>{new Date().toLocaleDateString()}</span>
                  </p>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Receipt #: <span>{shiftId}</span>
                  </p>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Customer ID: <span>{customer.company_id || "N/A"}</span>
                  </p>
                </div>
              </div>
            </div>

            <hr style={{ backgroundColor: "blue", height: "2px" }} />

            <div className="d-flex justify-content-between align-items-start">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ textAlign: "left" }}>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ fontSize: "1.2rem" }}>
                      Received From: {customer.name || "N/A"}
                    </h3>
                    <p style={{ fontSize: "0.9rem" }}>
                      {customer.address || "N/A"}
                    </p>
                    <p style={{ fontSize: "0.9rem" }}>
                      {customer.phone_number1 || "N/A"} /{" "}
                      {customer.phone_number2 || "N/A"}
                    </p>
                  </div>
                </div>

                <div style={{ marginLeft: 30 }}>
                  <h4>Shipping To:</h4>
                </div>
              </div>

              <div style={{ textAlign: "center", flex: 1 }}>
                <h2
                  className="invoice-text"
                  style={{
                    color: "red",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  TRANSACTION PAYMENTS
                </h2>
              </div>
            </div>

            <hr style={{ backgroundColor: "green", height: "2px" }} />
          </div>
        </div>

        {/* Updated Receipt Items Table */}
        <div
          className="modal-body"
          style={{ overflowY: "auto", backgroundColor: "white" }}
        >
          <div className="invoice-container" style={{ padding: "20px" }}>
          <div style={{ overflowX: "auto" }}>
              <table
                className="table table-striped table-bordered"
                style={{
                  backgroundColor: "white",
                  marginTop: "20px",
                  fontSize: "0.9rem",
                  width: "100%",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "skyblue" }}>
                    <th>Date</th>
                    <th>Amount Given</th>
                    <th>Payment Type</th>
                    <th>Bank Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{new Date().toLocaleDateString()}</td>
                    <td>${totalAmount.toFixed(2)}</td>
                    <td>{paymentType}</td>
                    <td>
                      {paymentType === "Bank"
                        ? `Bank - ${bankDetails.hr_bank_id} - (${bankDetails.bank_name}) - ${bankDetails.acc_number} - ${bankDetails.acc_name}`
                        : "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
  <div style={{ textAlign: "right" }}>
    <p>
      Total:{" "}
      <span style={{marginLeft: 20, fontSize: 20, marginRight: 20}}>
        ${totalAmount.toFixed(2)}
      </span>
    </p>
  </div>
</div>

        <div style={{ display: "flex" }}>
          <div style={{ alignContent: "center" }}>
            {branchDetails.length > 0 && (
              <div style={{ marginTop: "20px", alignContent: "end" }}>
                <strong>
                  {" "}
                  {branchDetails[0].branch_name}
                  <br></br>
                </strong>
                {companyDetails.address} <br></br>
                Phone: {companyDetails.phone_number1}
                <br></br>
                {branchDetails[0].branch_location} <br></br>
                {branchDetails[0].branch_city}
              </div>
            )}
          </div>

          <div style={{}}>
            <img
              src={`${
                companyDetails.footer_logo
                  ? `${UPLOADS_API_URL}/${companyDetails.footer_logo.replace(
                      /\\/g,
                      "/"
                    )}`
                  : "/assets/images/default-logo.png"
              }`}
              alt={`${companyDetails.trading_name} Logo`}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "250px",
                objectFit: "contain",
                marginBottom: "10px",
                alignSelf: "left",
              }}
            />
          </div>
        </div>

        {/* Footer with Actions */}
        <div className="modal-footer" style={{ marginBottom: 45 }}>
          <button className="btn btn-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button className="btn btn-primary mx-2" onClick={handlePrint}>
            Print Receipt
          </button>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default ReceiptPayments;